export class BasicTeamInformation {
    public id: string;
    public name: string | null = '';

    constructor();
    constructor(teamId: string, teamName: string | null);
    constructor(teamId?: string, teamName?: string | null) {
        if (teamId !== undefined) {
            this.id = teamId;
            this.name = teamName;
        }
    }
}
